import React, { FunctionComponent } from 'react';
import PaymentBottomSheet, { PaymentBottomSheetMessaging } from './PaymentBottomSheet';
import { PaymentLabels, InfoGroup } from '../component';

interface PaymentDeclineAlertBottomSheetProps {
    paymentLabels: PaymentLabels;
    gqlOrderId: string;
    paymentDeclineAlertTextOne: string;
    paymentDeclineAlertIngress: string;
    paymentDeclineAlertTextTwo: string;
    paymentInformation?: InfoGroup;
}

const PaymentDeclineAlertBottomSheet: FunctionComponent<PaymentDeclineAlertBottomSheetProps> = (props) => {
    const {
        paymentLabels,
        gqlOrderId,
        paymentDeclineAlertTextOne,
        paymentDeclineAlertIngress,
        paymentDeclineAlertTextTwo,
        paymentInformation
    } = props;

    const hbaDeclineMessage = paymentInformation?.annotations?.find(
        annotation => annotation.annotationType === 'HbaPaymentDecline'
    )?.label;

    const effectiveDeclineMessage = hbaDeclineMessage || paymentDeclineAlertTextOne;

    const paymentBottomSheetMessaging: PaymentBottomSheetMessaging = {
        addPaymentTitle: paymentLabels.addPaymentMethodTitle,
        addPaymentText: paymentLabels.addPaymentMethodText,
        declineMessage: effectiveDeclineMessage
    };

    return (
        <>
            <pui-text inline input={paymentDeclineAlertTextOne} />
            <pui-bottom-sheet
                id="payment-decline-modal"
                data-csa-c-content-id="payment-decline-modal"
                data-csa-c-type="popup"
                data-csa-c-slot-id="order-detail"
                inline
                closeable
                text={paymentDeclineAlertIngress}
                textSize="medium"
            >
                <PaymentBottomSheet
                    messaging={paymentBottomSheetMessaging}
                    gqlOrderId={gqlOrderId}
                />
            </pui-bottom-sheet>
            <pui-text inline input={paymentDeclineAlertTextTwo} />
        </>
    );
};

export default PaymentDeclineAlertBottomSheet;
